export const A11yWizardAdapterAPI = {
  name: 'a11y-wizard-adapter',
  layer: 'UI',
  public: true
};
export const A11yAdapterActionsAPI = {
  name: 'a11y-adapter-actions',
  layer: 'UI',
  public: true
};
export const A11yAdapterGettersAPI = {
  name: 'a11y-adapter-getters',
  layer: 'UI',
  public: true
};
export const A11yAdapterMultilingualGettersAPI = {
  name: 'a11y-adapter-multilingual-getters',
  layer: 'UI',
  public: true
};
export const A11yAdapterSettersAPI = {
  name: 'a11y-adapter-setters',
  layer: 'UI',
  public: true
};
export const A11yAdapterPanelAPI = {
  name: 'a11y-adapter-panel',
  layer: 'UI',
  public: true
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const A11yWizardDuplexerAPI = {
  name: 'A11yWizardDuplexerAPI',
  layer: 'DERIVATIVE_STATE',
  public: true
};
//# sourceMappingURL=repluggable-slot-keys.js.map